import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import { authService } from '../services/authService';

const ResetPasswordPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) {
      setError('Token mancante o non valido.');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const response = await authService.resetPassword(token, password);
      setSuccess(response.message);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Si è verificato un errore. Il link potrebbe essere scaduto.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper elevation={3} sx={{ padding: 4, width: 400, maxWidth: '90%' }}>
        <Typography variant="h5" gutterBottom align="center">
          Imposta Nuova Password
        </Typography>
        {success ? (
          <Alert severity="success">{success}</Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              label="Nuova Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              helperText="La password deve essere di almeno 8 caratteri."
              required
            />
            {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
              disabled={loading}
            >
              {loading ? 'Salvataggio...' : 'Salva Nuova Password'}
            </Button>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default ResetPasswordPage;
